import { render, staticRenderFns } from "./ConsultaDownloadModelo.vue?vue&type=template&id=1226c201&scoped=true"
import script from "./ConsultaDownloadModelo.vue?vue&type=script&lang=js"
export * from "./ConsultaDownloadModelo.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDownloadModelo.vue?vue&type=style&index=0&id=1226c201&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226c201",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1226c201')) {
      api.createRecord('1226c201', component.options)
    } else {
      api.reload('1226c201', component.options)
    }
    module.hot.accept("./ConsultaDownloadModelo.vue?vue&type=template&id=1226c201&scoped=true", function () {
      api.rerender('1226c201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ConsultaDownloadModelo.vue"
export default component.exports